module.exports = __webpack_public_path__ + "img/bannerPlaceholder.5fe33572.png";